// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataGrid_dataGrid__d8OGd {
  max-width: 100%;
  overflow: auto;
}
.DataGrid_dataGrid--fullWidth__SCqbg {
  width: 100%;
}
.DataGrid_dataGrid__col__I4XAL {
  padding: 0.5rem;
  color: var(--font-secondary-color);
}
.DataGrid_dataGrid__col--header__BusC2 {
  border-bottom: solid 1px #dbdbdb;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
}
.DataGrid_dataGrid__col--body__mqQiR {
  border-top: solid 1px #dbdbdb;
  font-weight: normal;
  font-size: 1rem;
  text-align: left;
}
.DataGrid_dataGrid__col--footer__ZucfG {
  border-top: solid 2px #dbdbdb;
  font-weight: bold;
  font-size: 1rem;
  text-align: left;
}
.DataGrid_dataGrid__col--align-left__KALxV {
  text-align: left;
}
.DataGrid_dataGrid__col--align-center__wvDF5 {
  text-align: center;
}
.DataGrid_dataGrid__col--align-right__iJO0a {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/DataGrid/DataGrid.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;AADF;AAGE;EACE,WAAA;AADJ;AAIE;EACE,eAAA;EACA,kCCRa;ADMjB;AAII;EACE,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAFN;AAKI;EACE,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAMI;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAOI;EACE,gBAAA;AALN;AAQI;EACE,kBAAA;AANN;AASI;EACE,iBAAA;AAPN","sourcesContent":["@import '@common/scss/_colors';\n\n.dataGrid {\n  max-width: 100%;\n  overflow: auto;\n\n  &--fullWidth {\n    width: 100%;\n  }\n\n  &__col {\n    padding: 0.5rem;\n    color: $font-secondary;\n\n    &--header {\n      border-bottom: solid 1px $grey-200;\n      font-weight: bold;\n      font-size: 1.2rem;\n      text-align: center;\n    }\n\n    &--body {\n      border-top: solid 1px $grey-200;\n      font-weight: normal;\n      font-size: 1rem;\n      text-align: left;\n    }\n\n    &--footer {\n      border-top: solid 2px $grey-200;\n      font-weight: bold;\n      font-size: 1rem;\n      text-align: left;\n    }\n\n    &--align-left {\n      text-align: left;\n    }\n\n    &--align-center {\n      text-align: center;\n    }\n\n    &--align-right {\n      text-align: right;\n    }\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataGrid": `DataGrid_dataGrid__d8OGd`,
	"dataGrid--fullWidth": `DataGrid_dataGrid--fullWidth__SCqbg`,
	"dataGrid__col": `DataGrid_dataGrid__col__I4XAL`,
	"dataGrid__col--header": `DataGrid_dataGrid__col--header__BusC2`,
	"dataGrid__col--body": `DataGrid_dataGrid__col--body__mqQiR`,
	"dataGrid__col--footer": `DataGrid_dataGrid__col--footer__ZucfG`,
	"dataGrid__col--align-left": `DataGrid_dataGrid__col--align-left__KALxV`,
	"dataGrid__col--align-center": `DataGrid_dataGrid__col--align-center__wvDF5`,
	"dataGrid__col--align-right": `DataGrid_dataGrid__col--align-right__iJO0a`
};
export default ___CSS_LOADER_EXPORT___;
